import * as t from 'io-ts';
import {
  Template,
  MySafetyHtmls,
  TopRoutes,
  CabData,
  LeaveIntentOffer,
  RouteInfo,
  NameUrl,
  InterlinkBlockDataChecker,
  cabsAggregatorData,
  CarTypeDataChecker,
  AggregateRating
} from '../../../src/pages/runtime-typechecker';
import { CouponData } from '../RouteTemplate/RouteDataTypeChecker';

export const CityDataForRoute = t.type({
  id: t.number,
  name: t.string,
  description: t.union([t.string, t.null]),
  latitude: t.union([t.string, t.null, t.number]),
  longitude: t.union([t.string, t.null, t.number]),
  code: t.string,
  placeId: t.string
});
export const CityData = t.type({
  id: t.number,
  name: t.string,
  description: t.union([t.null, t.undefined, t.string]),
  latitude: t.union([t.string, t.null, t.number]),
  longitude: t.union([t.string, t.null, t.number]),
  code: t.string,
  placeId: t.string,
  description2HTML: t.union([t.null, t.undefined, t.string])
});

export const RouteCabInfoChecker = t.type({
  seoUrl: t.union([t.undefined, t.null, t.string]),
  oneWayDistance: t.union([t.undefined, t.null, t.number]),
  oneWayDurationInHrMins: t.union([t.undefined, t.null, t.string])
});
export type CityCarTypeInfoData = t.TypeOf<typeof RouteCabInfoChecker>;

export const CityCarTypeTemplateChecker = t.type({
  id: t.number,
  isActive: t.boolean,
  url: t.string,
  description: t.union([t.string, t.null]),
  htmlRefreshDate: t.union([t.string, t.null]),
  created: t.string,
  modified: t.string,
  templateData: Template,
  topRoutesfromCity: t.array(CabData),
  topRoutesToCity: t.array(CabData),
  cityData: CityData,
  carTypeData: CarTypeDataChecker,
  otherCarTypeCabsFromSource: t.union([TopRoutes, t.undefined]),
  otherRoutesFromSource: t.union([t.array(RouteInfo), t.undefined]),
  otherRoutesToSource: t.union([t.array(RouteInfo), t.undefined]),
  cabsAggregatorData: cabsAggregatorData,
  airportCabs: t.union([t.array(NameUrl), t.undefined]),
  nearbyCities: t.union([t.undefined, t.array(NameUrl)]),
  mySafetyHtmls: t.union([t.undefined, MySafetyHtmls]),
  leaveIntentOffers: t.union([t.array(LeaveIntentOffer), t.undefined]),
  interlinks: t.union([t.undefined, t.array(InterlinkBlockDataChecker)]),
  hrPackages: t.union([t.array(t.string), t.undefined]),
  aggregateRating: AggregateRating,
  schemaMinFare: t.number,
  assistedFormOpenDelay: t.number,
  showTripAssistantButton: t.boolean,
  showTripAssistantButtonForDweb: t.boolean,
  showWhatsappWidget: t.boolean,
  whatsappWidgetDeeplink: t.string,
  customerCareNumber: t.string,
  assistantWidgetText: t.string,
  showWhatsAppForAssistedForm: t.boolean,
  showCallUsWidget: t.boolean,
  showCallUsForAssistedForm: t.boolean,
  inboundCallText: t.union([t.string, t.undefined]),
  inboundCallNumber: t.union([t.string, t.undefined]),
  showInboundCallNumberInDesktop: t.boolean,
  semCustomerCareNumber: t.string,
  semInboundCallNumber: t.union([t.string, t.undefined]),
  showCallusModalMweb: t.boolean,
  callusModalOpenDelay: t.number,
  showInboundNumberOnAssistedForm: t.boolean,
  couponInfo: CouponData,
  showLeaveIntentForm: t.boolean,
  whatsappTooltipText: t.string,
  tripAssistanceToolTipText: t.string,
  tripType: t.string,
  openTripTypeAndThenDate: t.boolean,
  openDateWidget: t.boolean,
  openTripType: t.boolean,
  packageData: t.any
});

export type CityCarTypeTemplateData = t.TypeOf<
  typeof CityCarTypeTemplateChecker
>;
